(function () {
  /**
   * Skip layout/paint work for below-fold sections until near viewport.
   * Visual result is unchanged once scrolled into view.
   */
  function markBelowFoldSections() {
    var root = document.getElementById('main');
    if (!root) return;

    var sections = root.querySelectorAll(':scope > .shopify-section, :scope > .shopify-section-group .shopify-section');
    if (!sections.length) {
      sections = root.querySelectorAll('.shopify-section');
    }
    if (sections.length < 3) return;

    var keep = 1;
    if (document.body && document.body.classList.contains('template-collection')) {
      // Banner + product grid (or first content block) stay painted for collection LCP.
      keep = 2;
    }

    sections.forEach(function (section, index) {
      if (index < keep) return;
      section.style.contentVisibility = 'auto';
      section.style.containIntrinsicSize = 'auto 900px';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', markBelowFoldSections);
  } else {
    markBelowFoldSections();
  }
})();
